import React from 'react';
import PropTypes from 'prop-types';
import { ArrowDownIcon } from 'components';
import classnames from 'classnames';

import './dropdown-menu.scss';

export class Dropdown extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    list: PropTypes.arrayOf(PropTypes.node),
    position: PropTypes.string,
    menuClassName: PropTypes.string,
    listClassName: PropTypes.string,
    arrowClassName: PropTypes.string,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    disabled: false,
    list: [],
    position: 'left',
    menuClassName: '',
    listClassName: '',
    arrowClassName: '',
    onOpen: undefined,
    onClose: undefined,
  };

  state = {
    showMenu: false,
  };

  menu = React.createRef();
  menuButton = React.createRef();

  outsideClickListener = (e) => {
    if (
      !this.menu?.current?.contains(e.target) &&
      !this.menuButton?.current?.contains(e.target)
    ) {
      this.toggleMenu();
    }
  };

  toggleMenu = () => {
    const { disabled, onOpen, onClose } = this.props;

    if (disabled) {
      return;
    }

    if (this.state.showMenu) {
      this.setState({ showMenu: false });
      onClose?.();
      window.document.removeEventListener(
        'touchstart',
        this.outsideClickListener,
        false,
      );
      window.document.removeEventListener(
        'mousedown',
        this.outsideClickListener,
        false,
      );
    } else {
      this.setState({ showMenu: true });
      onOpen?.();
      window.document.addEventListener(
        'touchstart',
        this.outsideClickListener,
        false,
      );
      window.document.addEventListener(
        'mousedown',
        this.outsideClickListener,
        false,
      );
    }
  };

  render() {
    const {
      children = null,
      list,
      menuClassName,
      listClassName,
      position,
      arrowClassName,
    } = this.props;
    const { showMenu } = this.state;

    return (
      <div className={classnames('dropdown-menu', menuClassName)}>
        <div
          ref={this.menuButton}
          onClick={() => {
            this.toggleMenu();
          }}
          className="dropdown-menu__button"
          data-testid="dropdown-menu-button"
        >
          {children}
          <ArrowDownIcon
            width="12px"
            height="12px"
            className={classnames({ _opened: showMenu }, arrowClassName)}
          />
        </div>
        <ul
          ref={this.menu}
          className={classnames(
            'dropdown-menu__list',
            listClassName,
            `_${position}`,
          )}
          style={{ display: !showMenu ? 'none' : 'block' }}
          data-testid="dropdown-menu-list"
        >
          {list.map((listItem, index) => (
            <li
              className="dropdown-menu__list-element"
              key={index}
              onClick={() => {
                this.toggleMenu();
              }}
              data-testid="dropdown-menu-list-item"
            >
              {listItem}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
